import React from "react"
import { Box, Text } from "@chakra-ui/react"

type Props = {
  product: any
}

const ProductDescriptionDesktop: React.FC<Props> = ({ product }) =>
  product?.description ? (
    <Box mt="4px" mb="24px">
      <Text variant="text16" lineHeight="24px" dangerouslySetInnerHTML={{ __html: product?.description }} />
    </Box>
  ) : null

export default React.memo(ProductDescriptionDesktop)
